import { useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

function EguProductSampleUpdateButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {

        if (grid) {
            setFormData({ ...(grid.selectedItems[0]) });

        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    const checkFormValidationCallback = (formData) => {

        if (parseInt(formData.passJudgment) === 3 && !(formData.confirmProductName)) {
            return [false, t('error.confirmProductnameNotExist')];
        }
        return [true, '']
    }

    const checkDisabledCallback = (formData, column) => {
        switch (column.name) {
            case "receiptNo":
                return true;
            default:
                break;
        }
    }

    return (

        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={schema ? t(`dialog.title.${schema.name}.update`) : ""}
                schema={schema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                checkFormValidationCallback={checkFormValidationCallback}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                checkDisabledCallback={checkDisabledCallback}
            />
        </>

    );
}

export default EguProductSampleUpdateButton;

